import { FormType } from '../../../form-types';
import { ZaludColdFluQuestionFieldAnswers } from './questions';

const coldFlu: FormType<ZaludColdFluQuestionFieldAnswers> = {
  name: 'Cold & Flu Intake',
  questions: [
    {
      key: 'zalud_coldFlu_redFlagSymptoms',
      next: {
        condition: { 'zalud_coldFlu_redFlagSymptoms.none': true },
        key: 'zalud_coldFlu_fever',
        els: 'zalud_coldFlu_ineligible'
      }
    },
    'zalud_coldFlu_fever',
    'zalud_coldFlu_symptoms',
    'zalud_coldFlu_additionalSymptoms',
    'zalud_coldFlu_symptomOnset',
    'zalud_coldFlu_covidTestPast10Days',
    'zalud_coldFlu_closeContact',
    'zalud_coldFlu_additionalComments',
    {
      key: 'zalud_coldFlu_consent',
      next: {
        condition: { 'zalud_coldFlu_consent.proceed': true },
        key: 'zalud_coldFlu_complete',
        els: 'zalud_coldFlu_ineligible'
      }
    },
    'zalud_coldFlu_complete',
    'zalud_coldFlu_ineligible'
  ]
};

export default coldFlu;
